import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth';
import coursesReducer from './courses';
import courseReducer from './course';
import lessonReducer from './lesson';
import studentsReducer from './students';
import studentReducer from './student';
import adminsReducer from './admins';
import adminReducer from './admin';
import schoolReducer from './school';
import schoolsReducer from './schools';
import codesReducer from './codes';
import arcadesReducer from './arcades';
import arcadeReducer from './arcade';
import trainingsReducer from './trainings';
import trainingReducer from './training';
import dailyChallengesReducer from './dailyChallenges';
import dailyChallengeReducer from './dailyChallenge';
import lessonRatingsSlice from './lesson-ratings';
import lessonReportsSlice from './lesson-reports';
import reviewsSlice from './reviews';
import unsubscribeReasonsSlice from './unsubscribe-reasons';
import surveysSlice from './surveys';
import lessonCategoriesSlice from './lesson-categories';
import lessonsSlice from './lessons';
import coursesLessonsSlice from './courses-lessons';

const store = configureStore({
  reducer: {
    auth: authReducer,
    courses: coursesReducer,
    currentCourse: courseReducer,
    currentLesson: lessonReducer,
    students: studentsReducer,
    currentStudent: studentReducer,
    admins: adminsReducer,
    currentAdmin: adminReducer,
    currentSchool: schoolReducer,
    schools: schoolsReducer,
    schoolCodes: codesReducer,
    arcades: arcadesReducer,
    currentArcade: arcadeReducer,
    trainings: trainingsReducer,
    currentTraining: trainingReducer,
    dailyChallenges: dailyChallengesReducer,
    currentDailyChallenge: dailyChallengeReducer,
    lessonRatings: lessonRatingsSlice,
    lessonReports: lessonReportsSlice,
    reviews: reviewsSlice,
    unsubscribeReasons: unsubscribeReasonsSlice,
    surveys: surveysSlice,
    lessonCategories: lessonCategoriesSlice,
    lessons: lessonsSlice,
    coursesLessons: coursesLessonsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
